export default "__VITE_ASSET__BRJ95940__"